// packages import
import { DashboardContainer } from "../../../containers/DashboardContainer";

export const Dashboard = (): JSX.Element => <DashboardContainer />